<div class="row margin-top-8">
    <div class="col-md-1 label" style="white-space: nowrap;">
        {{ "general.headers.coupons.linked_to" | translate }}
    </div>
    <div class="col-md-1 label">
        {{ "bikeshop.dashboard.jobcard" | translate }}
    </div>
    <div class="col-md-3 label">
        {{ "bikeshop.modal.shared.bike.service_date" | translate }}
    </div>
    <div class="col-md-3 label">
        {{ "bikeshop.calendar.availability.technician" | translate}}
    </div>
    <div class="col-md-3 label">
        {{ "bikeshop.inventory_audit.status" | translate }}
    </div>
    <div class="col-md-1 label">
        {{ "bikeshop.modal.update_job_card.quote.total" | translate }}
    </div>
</div>
<div class="row margin-top-8" *ngFor="let service of services; let i = index">
    <div class="col-md-1 value">
        <p-inputSwitch *ngIf="service.StatusID !== 40 && service.StatusID !== 45 && service.StatusID !== 50"

                       [ngModel]="service.Linked === 1"
                       (onChange)="LinkOrUnlink(service.ID)"></p-inputSwitch>
        <p-inputSwitch *ngIf="service.StatusID === 40 || service.StatusID === 45 || service.StatusID === 50"
                       [ngModel]="service.Linked === 1" [disabled]></p-inputSwitch>
    </div>
    <div class="col-md-1 label">
        {{service.JobCardID}}
    </div>
    <div class="col-md-3 label">
        {{ service.DateCheckedIn | date:'medium' }}
    </div>
    <div class="col-md-3 label">
        {{service.Technician}}
    </div>
    <div class="col-md-3 label">
        {{service.Status}}
    </div>
    <div class="col-md-1 label">
        {{partnerData.CurrencySymbol}}{{service.Total}}
    </div>
</div>


